import React from "react";
import { createPortal } from "react-dom";
import { AlertTriangle } from "lucide-react";

/** Mobile-only dialog for invalid sourcing quick-bar values. */
export default function MobileQuickValidationDialog({ fieldLabel, message, onClose }) {
  if (!message || typeof document === "undefined") return null;

  return createPortal(
    <div className="fixed inset-0 z-[960] flex items-center justify-center px-3 md:hidden">
      <button
        type="button"
        className="absolute inset-0 bg-slate-900/45"
        aria-label="Dismiss"
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="mobile-quick-validation-title"
        className="relative z-10 w-full max-w-[18rem] rounded-xl bg-white px-3.5 py-3 shadow-xl border border-slate-200"
      >
        <div className="flex items-start gap-2">
          <AlertTriangle className="h-4 w-4 text-amber-500 shrink-0 mt-0.5" aria-hidden />
          <div className="min-w-0">
            <h2 id="mobile-quick-validation-title" className="text-sm font-semibold text-slate-900 leading-snug">
              Check your figures
            </h2>
            {fieldLabel ? (
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-sky-700">
                {fieldLabel}
              </p>
            ) : null}
            <p className="mt-1 text-xs text-slate-700 leading-snug">{message}</p>
          </div>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="mt-3 w-full rounded-lg bg-sky-600 px-3 py-2 text-xs font-semibold text-white hover:bg-sky-700"
        >
          OK
        </button>
      </div>
    </div>,
    document.body
  );
}

export function isMobileViewport() {
  return typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;
}
